import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Modal } from "react-bootstrap";


function ModalEditRole({ show, onClose, user = {}, save }) {
    const [roles, setRoles] = useState([]);
    const [selected, setSelect] = useState(null);

    function convertoArray(roles) {
        let array = [];
        for (let key in roles) {
            if (roles.hasOwnProperty(key)) {
                let rol = { value: "", desc: "" };
                rol.value = key;
                rol.desc = roles[key];

                array.push(rol);
            }
        }
        setRoles(array);
    }

    useEffect(() => {
        axios
            .get("access/roles")
            .then((result) => {
                convertoArray(result.data.roles);
            })
            .catch(() => {
                toast.error("Problemas para conectarse con el servidor");
            });
    }, []);

    function localSave() {
        toast("Cambiando Rol");
        save(selected);
    }

    return (
        <Modal show={show} onHide={onClose} className="kr-modal">
            <Modal.Header>
                <h4>Cambia el Rol de {user?.name}</h4>
            </Modal.Header>

            <Modal.Body>
                <div className="form-group">
                    <select
                        className="form-control"
                        onChange={({ target }) => setSelect(target.value)}
                    >
                        <option value="">Seleccione una opcion</option>
                        {roles.map((elm, i) => (
                            <option key={i} value={elm.value}>
                                {elm.desc}
                            </option>
                        ))}
                    </select>
                </div>

                <button
                    onClick={localSave}
                    disabled={!Boolean(selected)}
                    className="btn btn--small btn--purple"
                >
                    Guardar
                </button>
            </Modal.Body>
        </Modal>
    );
}


export default ModalEditRole